import React from 'react';
import './GalleryMedia.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';

const GalleryMedia = () => {
  return (
    <div className="gallery_app">
      <SideMenuBar />

      <main className="content">
        <NewHeader />

        <div className="gallery_container">
          <section className="gallery_page_heading">
            <div>
              <span className="page_kicker">PROJECT ASSETS</span>
              <h1>Gallery</h1>
              <p>Keep project media and documents organized in one workspace.</p>
            </div>

            <div className="gallery_stats">
              <span className="gallery_stat_dot" />
              <span>Media workspace</span>
            </div>
          </section>

          <section className="gallery_workspace">
            <div className="gallery_workspace_header">
              <div className="gallery_tabs">
                <a href="/GalleryMedia" className="gallery_tab active">
                  <span className="gallery_tab_icon">▧</span>
                  Media
                </a>
                <a href="/GalleryDoc" className="gallery_tab">
                  <span className="gallery_tab_icon">▤</span>
                  Documents
                </a>
              </div>

              <div className="gallery_header_hint">
                <span>MEDIA LIBRARY</span>
                <strong>Ready for uploads</strong>
              </div>
            </div>

            <div className="gallery_empty_state">
              <div className="gallery_upload_visual">
                <div className="gallery_upload_icon_wrap">
                  <img src="../assets/gallery.png" alt="" className="uploadPhoto_icon_GalleryMedia" />
                </div>
                <span className="upload_glow" />
              </div>

              <span className="page_kicker">MEDIA</span>
              <h2>Create your project media library</h2>
              <p>
                Keep photos, videos and visual project references together so your team
                can find the right asset quickly.
              </p>

              <a href="/" className="gallery_primary_action">
                <span>＋</span>
                Upload media
              </a>

              <div className="gallery_upload_meta">
                <span>JPG</span>
                <span>PNG</span>
                <span>MP4</span>
                <span>MOV</span>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default GalleryMedia;
